import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import AsyncSelect from 'react-select/async';
import { categoriasDeGraficos } from '../../common/utils';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash, FaCheck } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class DoencasPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            doencas: [],
            doencaSelecionada: [{doenca_id: '', doenca_nome: '', idade_minima: '', idade_maxima: '', focusDoenca: false, doencaSearchTimeout: null}],
            programa_id: this.props.programa_id,
            dadosDoencaPrincipal: this.props.dadosDoencaPrincipal,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarDoencasRelacionadas();
    }

    carregarDoencasRelacionadas = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/doencas/?programa_id=${this.state.programa_id}&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    doencas: {
                        ...response.data,
                        results:response.data.results.map(doenca => ({
                            id: doenca.id,
                            doenca_id: doenca.dados_doenca.id,
                            doenca_nome: doenca.dados_doenca.nome,
                            idade_minima: doenca.idade_minima,
                            idade_maxima: doenca.idade_maxima
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar doencas:', error);
                
                let erro_msg = 'Erro ao carregar doencas do programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleDoencasChange = (e, fieldName, bool = false) => {
        if(fieldName === 'validacao_doenca') {
            this.setState({ dadosDoencaPrincipal: { ...this.state.dadosDoencaPrincipal, [fieldName]: e.target.value } });
        } else if(fieldName === 'label_doencas') {
            this.setState({ dadosDoencaPrincipal: { ...this.state.dadosDoencaPrincipal, [fieldName]: e.target.value } });
        } else if(fieldName === 'exige_confirmacao_diagnostico') {
            this.setState({ dadosDoencaPrincipal: { ...this.state.dadosDoencaPrincipal, [fieldName]: bool } });
        } else if(fieldName === 'doenca_principal_id') {
            this.setState({ dadosDoencaPrincipal: { ...this.state.dadosDoencaPrincipal, doenca_principal_id: e.value, doenca_principal_nome: e.label } });
        } 
        else if(fieldName === 'doenca_id') {
            this.setState({ doencaSelecionada: { ...this.state.doencaSelecionada, doenca_id: e.value, doenca_nome: e.label} });
        }
        else {
            const { name, value } = e.target;
            this.setState({ doencaSelecionada: { ...this.state.doencaSelecionada, [name]: value } });
        }
    }

    handleSalvarDoenca = async () => {
        const formData = new FormData();
        const url = this.state.doencaSelecionada.id ? `/programas/doencas/${this.state.doencaSelecionada.id}/` : '/programas/doencas/';
        const metodo = this.state.doencaSelecionada.id ? 'put' : 'post';

        const dadosDoenca = {
            programa_id: this.state.programa_id,
            doenca_id: this.state.doencaSelecionada.doenca_id,
            idade_minima: this.state.doencaSelecionada.idade_minima,
            idade_maxima: this.state.doencaSelecionada.idade_maxima,
        };
        
        api({
            method: metodo,
            url: url,
            data: dadosDoenca,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.doencaSelecionada.id) ? 'Doença atualizada com sucesso' : 'Doença cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

            this.carregarDoencasRelacionadas();
            this.handleCloseModalDoencas();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a doença, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos) {
                    var value = campos[key];
    
                    if (key === 'doenca_id') {
                        content += `<br>&bull; Doença: ${value}`;
                    }
                    if (key === 'idade_minima') {
                        content += `<br>&bull; Idade Mínima: ${value}`;
                    }
                    if (key === 'idade_maxima') {
                        content += `<br>&bull; Idade Máxima: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerDoenca = (doenca) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover doença?',
            text: "Tem certeza que deseja remover a doença " + doenca.doenca_nome + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (doenca.id) {
                    api({
                        method: 'delete',
                        url: `/programas/doencas/${doenca.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Doença removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarDoencasRelacionadas();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a doença, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        doencas: prevState.doencas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A doença foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    carregarDoencas = async (inputValue, tipo = "principal") => {
        if(tipo === "principal") {
            if(!this.state.focusDoencaPrincipal) {
                return [];
            }
        } else if(tipo === "relacionada") {
            if(!this.state.doencaSelecionada.focusDoencaRelacionada) {
                return [];
            }
        }
        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    }

    handleShowModalDoencas = (doenca = []) => {
        this.setState({ showModalDoencas: true, doencaSelecionada: doenca });
    }

    handleCloseModalDoencas = () => {
        this.setState({ showModalDoencas: false, doencaSelecionada: []});
    }

    onClickPaginaDoencas = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarDoencas(num_page)
        });
    };

    enviaDoencaPrincipal = async () => {
        const formData = new FormData();
    
        const url = this.state.programa_id ? '/programas/' + this.state.programa_id + '/' : '/programas/';
        const metodo = this.state.programa_id ? 'put' : 'post';

        if (this.state.dadosDoencaPrincipal.validacao_doenca) {
            formData.append('validacao_doenca', this.state.dadosDoencaPrincipal.validacao_doenca);
        }
        
        formData.append('exige_confirmacao_diagnostico', this.state.dadosDoencaPrincipal.exige_confirmacao_diagnostico);
        
        if (this.state.dadosDoencaPrincipal.doenca_principal_id) {
            formData.append('doenca_principal_id', this.state.dadosDoencaPrincipal.doenca_principal_id);
        }

        if (this.state.dadosDoencaPrincipal.label_doencas) {
            formData.append('label_doencas', this.state.dadosDoencaPrincipal.label_doencas);
        }
    
        try {
            // Enviar os dados para o backend
            const response = await api({
                method: metodo,
                url: url,
                data: formData,
            });
    
            // Exibir a mensagem de sucesso
            const MySwal = withReactContent(Swal);
            const textSwal = 'Doença principal atualizada com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
    
            this.setState({
                loading: false,
            });
    
        } catch (error) {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;
                // Adicionar lógica para exibir mensagens de erro específicas, se necessário
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            });
    
            this.setState({
                loading: false,
            });
        }
    }


    render() {
        return (
            <div className="cardDestaque mt-4" style={{backgroundColor: '#f3f3f3'}}>
            <Tabs defaultActiveKey="doencas" id="tabs-doencas-programa" className="aditus-tabs">
                <Tab eventKey="doencas" title="Doenças do Programa">
                    <Card className="cardDestaque mt-4">
                        <Card.Body>    
                            <Row>
                                <h4>Doenças do Programa</h4>
                                <Col sm={6} xd={12}>
                                    <Form.Group>
                                        <Form.Label>Local da Seleção da Doença </Form.Label>
                                            <Form.Control as="select" className="form-control" name="validacao_doenca" value={this.state.dadosDoencaPrincipal.validacao_doenca || ''} onChange={(e) => this.handleDoencasChange(e, 'validacao_doenca')}>
                                                <option value="paciente">Paciente</option>
                                                <option value="atendimento">Atendimento</option>
                                            </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Label Doenças</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="label_doencas"
                                            value={this.state.dadosDoencaPrincipal.label_doencas || ''}
                                            onChange={(e) => this.handleDoencasChange(e, 'label_doencas')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Exige Confirmação de Diagnóstico?</Form.Label>
                                        <div>
                                            <Button 
                                                variant={this.state.dadosDoencaPrincipal.exige_confirmacao_diagnostico ? "success" : "outline-secondary"}
                                                onClick={(e) => this.handleDoencasChange(e, 'exige_confirmacao_diagnostico', true)}>
                                                Sim
                                            </Button>
                                            {' '}
                                            <Button 
                                                variant={!this.state.dadosDoencaPrincipal.exige_confirmacao_diagnostico ? "danger" : "outline-secondary"}
                                                onClick={(e) => this.handleDoencasChange(e, 'exige_confirmacao_diagnostico', false)}>
                                                Não
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Row>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Doença Principal</Form.Label>
                                            <AsyncSelect
                                                    key={this.state.focusDoencaPrincipal}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.doencaPrincipalSearchTimeout);
                                                            this.doencaPrincipalSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarDoencas(inputValue));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusDoencaPrincipal: true
                                                        });
                                                    }}
                                                autoFocus={this.state.focusDoencaPrincipal}
                                                openMenuOnFocus={this.state.focusDoencaPrincipal}
                                                defaultOptions
                                                name="doenca_principal_id"
                                                placeholder="Buscar doença..."
                                                noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                onChange={(e) => this.handleDoencasChange(e, 'doenca_principal_id')}
                                                value={this.state.dadosDoencaPrincipal.doenca_principal_id ? { value: this.state.dadosDoencaPrincipal.doenca_principal_id, label: this.state.dadosDoencaPrincipal.doenca_principal_nome} : null}
                                                
                                            />
                                            <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Col sm={6} xs={12}>
                                    <Button variant="success" className="btn-submit mt-3" disabled={this.state.loading} onClick={(e) => this.enviaDoencaPrincipal()}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar Doeça do Programa
                                            </>
                                        )}
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Tab>
                <Tab eventKey="doencasPatologias" title="Patalogias Relacionadas">
                    <Card className="cardDestaque mt-4">
                        <Card.Body>                   
                            <Row className="align-items-center mb-3">
                                <Col sm={6} lg={6}>
                                    <h6><strong>Patologias Relacionadas</strong></h6>
                                </Col>
                                <Col sm={6} xs={6} className="text-end">                       
                                    <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalDoencas()}>
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Doença'}                                       
                                    </Button>
                                </Col>
                            </Row>
                            {('results' in this.state.doencas && this.state.doencas.results.length > 0) ? (
                                <Row>
                                    <Col sm={12} lg={12}>
                                        <Table responsive className="custom-table">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Patologia</th>
                                                    <th>Idade Mínima</th>
                                                    <th>Idade Máxima</th>
                                                    <th>Opções</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.doencas.results.map((doenca, index) => ( 
                                                    <tr key={index}>
                                                        <td className="bg-id">#{doenca.id}</td>
                                                        <td className="td-border">{doenca.doenca_nome}</td>
                                                        <td className="td-border">{doenca.idade_minima}</td>
                                                        <td className="td-border">{doenca.idade_maxima}</td>
                                                        <td>
                                                            <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalDoencas(doenca)}>
                                                                <FaEdit /> Editar
                                                            </Button>  
                                                            <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerDoenca(doenca)}>
                                                                <FaTrash /> Remover
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                            {'results' in this.state.doencas && this.state.doencas.results.length > 0 && (
                                                <Paginacao dados={this.state.doencas} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaDoencas} />
                                            )}
                                    </Col>
                                </Row>   
                            ) : (
                                <p>Nenhuma doença cadastrada até o momento</p>
                            )}
                                    
                        </Card.Body>                
                    </Card>
                </Tab>
            </Tabs>


            <Modal show={this.state.showModalDoencas} onHide={this.handleCloseModalDoencas} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.doencaSelecionada.id ? 'Editar Doença #' + this.state.doencaSelecionada.id : 'Adicionar Doença'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h4>Doenças</h4>
                            <div className="row-list">
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Patologia</Form.Label>
                                            <AsyncSelect
                                                key={this.state.doencaSelecionada.focusDoencaRelacionada}
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.state.doencaSelecionada.doencaRelacionadaSearchTimeout);
                                                        this.state.doencaSelecionada.doencaRelacionadaSearchTimeout = setTimeout(() => {
                                                            resolve(this.carregarDoencas(inputValue, "relacionada"));
                                                        }, 700);
                                                    });
                                                }}
                                                onFocus={() => {
                                                    this.setState({
                                                        doencaSelecionada: { ...this.state.doencaSelecionada, focusDoencaRelacionada: true }
                                                    });
                                                }}
                                                autoFocus={this.state.doencaSelecionada.focusDoencaRelacionada}
                                                openMenuOnFocus={this.state.doencaSelecionada.focusDoencaRelacionada}
                                                defaultOptions
                                                name="doenca_id"
                                                placeholder="Buscar doença..."
                                                noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                onChange={(selectedOption) => this.handleDoencasChange(selectedOption, 'doenca_id')}
                                                value={this.state.doencaSelecionada.doenca_id ? { value: this.state.doencaSelecionada.doenca_id, label: this.state.doencaSelecionada.doenca_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {this.state.doencaSelecionada.doenca_id && (
                                        <>
                                            <Col sm={4} xs={12}>
                                                <Form.Group>
                                                    <Form.Label>Idade Mínima</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="idade_minima"
                                                        value={this.state.doencaSelecionada.idade_minima}
                                                        onChange={(e) => this.handleDoencasChange(e, 'idade_minima')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group>
                                                    <Form.Label>Idade Máxima</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="idade_maxima"
                                                        value={this.state.doencaSelecionada.idade_maxima}
                                                        onChange={(e) => this.handleDoencasChange(e, 'idade_maxima')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                    )}
                                </Row>
                            </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalDoencas}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={this.handleSalvarDoenca}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </div>
        );
    }
}

export default DoencasPrograma;

